// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.server-logs {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #0f172a;
  border: 1px solid #334155;
  border-radius: 6px;
  overflow: hidden;
}

.logs-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  border-bottom: 1px solid #334155;
  background-color: #1e293b;
}

.logs-header h3 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #f1f5f9;
}

.logs-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.search-box {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1 1;
  min-width: 200px;
  padding: 6px 8px;
  background-color: #0f172a;
  border: 1px solid #334155;
  border-radius: 4px;
  color: #cbd5e1;
}

.search-box svg {
  color: #64748b;
  flex-shrink: 0;
}

.search-input {
  flex: 1 1;
  background-color: transparent;
  border: none;
  color: #cbd5e1;
  font-size: 12px;
  outline: none;
}

.search-input::placeholder {
  color: #475569;
}

.clear-search {
  background-color: transparent;
  border: none;
  color: #64748b;
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}

.clear-search:hover {
  color: #f1f5f9;
}

.filter-dropdown {
  position: relative;
}

.filter-dropdown-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-width: 120px;
  padding: 6px 8px;
  background-color: #0f172a;
  border: 1px solid #334155;
  border-radius: 4px;
  color: #cbd5e1;
  font-size: 11px;
  cursor: pointer;
}

.filter-dropdown-button:hover {
  border-color: #475569;
  color: #f1f5f9;
}

.filter-dropdown-menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 140px;
  padding: 8px;
  background-color: #111827;
  border: 1px solid #334155;
  border-radius: 6px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
}

.filter-mode-toggle {
  display: flex;
  gap: 4px;
  margin-bottom: 2px;
}

.filter-mode-toggle button,
.filter-option {
  border: 1px solid #334155;
  background-color: #0f172a;
  color: #cbd5e1;
  border-radius: 4px;
  padding: 4px 6px;
  font-size: 11px;
  cursor: pointer;
  text-align: left;
}

.filter-mode-toggle button.active,
.filter-option.selected {
  background-color: #1d4ed8;
  border-color: #60a5fa;
  color: #eff6ff;
}

.filter-option {
  width: 100%;
}

.logs-button {
  padding: 6px 8px;
  background-color: transparent;
  border: 1px solid #475569;
  border-radius: 4px;
  color: #cbd5e1;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logs-button:hover:not(:disabled) {
  border-color: #64748b;
  color: #f1f5f9;
}

.logs-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.logs-button.clear:hover {
  background-color: rgba(239, 68, 68, 0.1);
  border-color: #ef4444;
  color: #ef4444;
}

.logs-button.refresh:hover {
  background-color: rgba(59, 130, 246, 0.1);
  border-color: #3b82f6;
  color: #3b82f6;
}

.auto-scroll-label {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 12px;
  color: #cbd5e1;
  transition: color 0.2s;
}

.auto-scroll-label:hover {
  color: #f1f5f9;
}

.auto-scroll-label input {
  cursor: pointer;
  width: 14px;
  height: 14px;
}

.logs-container {
  flex: 1 1;
  overflow-y: auto;
  font-family: 'Monaco', 'Courier New', monospace;
  font-size: 11px;
  background-color: #0f172a;
  padding: 0;
}

.logs-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 6px 12px;
  background-color: #0f172a;
  border-bottom: 1px solid #1e293b;
  font-size: 11px;
  color: #64748b;
}

.last-heartbeat {
  color: #fbbf24;
  font-weight: 600;
}

.logs-empty {
  padding: 20px;
  text-align: center;
  color: #64748b;
  font-size: 12px;
}

.log-entry {
  display: flex;
  align-items: flex-start;
  padding: 6px 12px;
  border-bottom: 1px solid #1e293b;
  gap: 8px;
  line-height: 1.4;
  cursor: pointer;
}

.log-entry:hover {
  background-color: #1e293b;
}

.log-selected {
  background-color: rgba(59, 130, 246, 0.18);
  box-shadow: inset 2px 0 0 #3b82f6;
}

.log-time {
  color: #64748b;
  flex-shrink: 0;
  min-width: 70px;
  font-weight: 600;
}

.log-level {
  flex-shrink: 0;
  min-width: 45px;
  font-weight: 600;
  padding: 0 4px;
  border-radius: 2px;
  font-size: 10px;
  text-align: center;
}

.log-level-info {
  color: #0ea5e9;
  background-color: rgba(6, 182, 212, 0.1);
}

.log-level-warn {
  color: #eab308;
  background-color: rgba(250, 204, 21, 0.1);
}

.log-level-error {
  color: #ef4444;
  background-color: rgba(239, 68, 68, 0.1);
}

.log-level-debug {
  color: #a78bfa;
  background-color: rgba(168, 85, 247, 0.1);
}

.log-message {
  color: #e2e8f0;
  flex: 1 1;
  word-break: break-word;
  white-space: pre-wrap;
}

/* Scrollbar styling */
.logs-container::-webkit-scrollbar {
  width: 8px;
}

.logs-container::-webkit-scrollbar-track {
  background: #0f172a;
}

.logs-container::-webkit-scrollbar-thumb {
  background: #334155;
  border-radius: 4px;
}

.logs-container::-webkit-scrollbar-thumb:hover {
  background: #475569;
}
`, "",{"version":3,"sources":["webpack://./src/components/ServerLogs.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,6BAA6B;EAC7B,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,+CAA+C;EAC/C,eAAe;EACf,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,gCAAgC;EAChC,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,SAAO;EACP,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".server-logs {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  background-color: #0f172a;\r\n  border: 1px solid #334155;\r\n  border-radius: 6px;\r\n  overflow: hidden;\r\n}\r\n\r\n.logs-header {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  padding: 12px;\r\n  border-bottom: 1px solid #334155;\r\n  background-color: #1e293b;\r\n}\r\n\r\n.logs-header h3 {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #f1f5f9;\r\n}\r\n\r\n.logs-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.search-box {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  flex: 1;\r\n  min-width: 200px;\r\n  padding: 6px 8px;\r\n  background-color: #0f172a;\r\n  border: 1px solid #334155;\r\n  border-radius: 4px;\r\n  color: #cbd5e1;\r\n}\r\n\r\n.search-box svg {\r\n  color: #64748b;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.search-input {\r\n  flex: 1;\r\n  background-color: transparent;\r\n  border: none;\r\n  color: #cbd5e1;\r\n  font-size: 12px;\r\n  outline: none;\r\n}\r\n\r\n.search-input::placeholder {\r\n  color: #475569;\r\n}\r\n\r\n.clear-search {\r\n  background-color: transparent;\r\n  border: none;\r\n  color: #64748b;\r\n  cursor: pointer;\r\n  padding: 2px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: color 0.2s;\r\n}\r\n\r\n.clear-search:hover {\r\n  color: #f1f5f9;\r\n}\r\n\r\n.filter-dropdown {\r\n  position: relative;\r\n}\r\n\r\n.filter-dropdown-button {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n  min-width: 120px;\r\n  padding: 6px 8px;\r\n  background-color: #0f172a;\r\n  border: 1px solid #334155;\r\n  border-radius: 4px;\r\n  color: #cbd5e1;\r\n  font-size: 11px;\r\n  cursor: pointer;\r\n}\r\n\r\n.filter-dropdown-button:hover {\r\n  border-color: #475569;\r\n  color: #f1f5f9;\r\n}\r\n\r\n.filter-dropdown-menu {\r\n  position: absolute;\r\n  top: calc(100% + 4px);\r\n  left: 0;\r\n  z-index: 20;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  min-width: 140px;\r\n  padding: 8px;\r\n  background-color: #111827;\r\n  border: 1px solid #334155;\r\n  border-radius: 6px;\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);\r\n}\r\n\r\n.filter-mode-toggle {\r\n  display: flex;\r\n  gap: 4px;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.filter-mode-toggle button,\r\n.filter-option {\r\n  border: 1px solid #334155;\r\n  background-color: #0f172a;\r\n  color: #cbd5e1;\r\n  border-radius: 4px;\r\n  padding: 4px 6px;\r\n  font-size: 11px;\r\n  cursor: pointer;\r\n  text-align: left;\r\n}\r\n\r\n.filter-mode-toggle button.active,\r\n.filter-option.selected {\r\n  background-color: #1d4ed8;\r\n  border-color: #60a5fa;\r\n  color: #eff6ff;\r\n}\r\n\r\n.filter-option {\r\n  width: 100%;\r\n}\r\n\r\n.logs-button {\r\n  padding: 6px 8px;\r\n  background-color: transparent;\r\n  border: 1px solid #475569;\r\n  border-radius: 4px;\r\n  color: #cbd5e1;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.logs-button:hover:not(:disabled) {\r\n  border-color: #64748b;\r\n  color: #f1f5f9;\r\n}\r\n\r\n.logs-button:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.logs-button.clear:hover {\r\n  background-color: rgba(239, 68, 68, 0.1);\r\n  border-color: #ef4444;\r\n  color: #ef4444;\r\n}\r\n\r\n.logs-button.refresh:hover {\r\n  background-color: rgba(59, 130, 246, 0.1);\r\n  border-color: #3b82f6;\r\n  color: #3b82f6;\r\n}\r\n\r\n.auto-scroll-label {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  color: #cbd5e1;\r\n  transition: color 0.2s;\r\n}\r\n\r\n.auto-scroll-label:hover {\r\n  color: #f1f5f9;\r\n}\r\n\r\n.auto-scroll-label input {\r\n  cursor: pointer;\r\n  width: 14px;\r\n  height: 14px;\r\n}\r\n\r\n.logs-container {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  font-family: 'Monaco', 'Courier New', monospace;\r\n  font-size: 11px;\r\n  background-color: #0f172a;\r\n  padding: 0;\r\n}\r\n\r\n.logs-info {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 6px 12px;\r\n  background-color: #0f172a;\r\n  border-bottom: 1px solid #1e293b;\r\n  font-size: 11px;\r\n  color: #64748b;\r\n}\r\n\r\n.last-heartbeat {\r\n  color: #fbbf24;\r\n  font-weight: 600;\r\n}\r\n\r\n.logs-empty {\r\n  padding: 20px;\r\n  text-align: center;\r\n  color: #64748b;\r\n  font-size: 12px;\r\n}\r\n\r\n.log-entry {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  padding: 6px 12px;\r\n  border-bottom: 1px solid #1e293b;\r\n  gap: 8px;\r\n  line-height: 1.4;\r\n  cursor: pointer;\r\n}\r\n\r\n.log-entry:hover {\r\n  background-color: #1e293b;\r\n}\r\n\r\n.log-selected {\r\n  background-color: rgba(59, 130, 246, 0.18);\r\n  box-shadow: inset 2px 0 0 #3b82f6;\r\n}\r\n\r\n.log-time {\r\n  color: #64748b;\r\n  flex-shrink: 0;\r\n  min-width: 70px;\r\n  font-weight: 600;\r\n}\r\n\r\n.log-level {\r\n  flex-shrink: 0;\r\n  min-width: 45px;\r\n  font-weight: 600;\r\n  padding: 0 4px;\r\n  border-radius: 2px;\r\n  font-size: 10px;\r\n  text-align: center;\r\n}\r\n\r\n.log-level-info {\r\n  color: #0ea5e9;\r\n  background-color: rgba(6, 182, 212, 0.1);\r\n}\r\n\r\n.log-level-warn {\r\n  color: #eab308;\r\n  background-color: rgba(250, 204, 21, 0.1);\r\n}\r\n\r\n.log-level-error {\r\n  color: #ef4444;\r\n  background-color: rgba(239, 68, 68, 0.1);\r\n}\r\n\r\n.log-level-debug {\r\n  color: #a78bfa;\r\n  background-color: rgba(168, 85, 247, 0.1);\r\n}\r\n\r\n.log-message {\r\n  color: #e2e8f0;\r\n  flex: 1;\r\n  word-break: break-word;\r\n  white-space: pre-wrap;\r\n}\r\n\r\n/* Scrollbar styling */\r\n.logs-container::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n.logs-container::-webkit-scrollbar-track {\r\n  background: #0f172a;\r\n}\r\n\r\n.logs-container::-webkit-scrollbar-thumb {\r\n  background: #334155;\r\n  border-radius: 4px;\r\n}\r\n\r\n.logs-container::-webkit-scrollbar-thumb:hover {\r\n  background: #475569;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
